import { Button, Card, Stack, Text, Title } from '@mantine/core';
import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

export function NotFoundPage() {
  const { t } = useTranslation('common');

  return (
    <Card withBorder radius="md" padding="xl" maw={520}>
      <Stack gap="sm" align="flex-start">
        <Title order={2}>{t('notFound.title')}</Title>
        <Text c="dimmed" size="sm">
          {t('notFound.description')}
        </Text>
        <Button component={Link} to="/" variant="light">
          {t('action.goHome')}
        </Button>
      </Stack>
    </Card>
  );
}
